import serviceAreaData from "../data/serviceAreaData";
import React from "react";

const ServiceArea = () => {
  return (
    <section className="service-area">
      <div className="container">
        <div className="section-intro">
          <h2 className="section-title" style={{fontSize:'32px'}}>Our Service Network</h2>
          <p style={{fontSize:'20px'}}>
            Professional RO services across major localities of Patna.
          </p>
        </div>

        <div className="india-map-container">
          <h3 className="text-center">Patna Service Coverage</h3>
          <p className="text-center">
            We provide RO installation, repair, and maintenance services
            throughout Patna.
          </p>

          <div className="area-card">
            <h3>
              <i className="fas fa-map-marker-alt"></i> Service serviceAreaData in Patna
            </h3>

            <ul className="area-list">
              {serviceAreaData.map((area, index) => (
                <li key={index}>{area}</li>
              ))}
            </ul>
          </div>

          <div className="highlight-box">
            <p>
              <strong>Service Note:</strong> Charges may vary based on service
              type. Call for exact pricing:
              <span className="tollfree"> +91 80802 67034</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;